module.exports = __webpack_public_path__ + "images/hemelektronik.b7ba87a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/hemelektronik.jpg
// module id = ea36d683
// module chunks = 10 37